function Ascending({ dimensions, col = '#000' }) {
  const baseXml = `
        <svg width=${dimensions || '20'} height=${dimensions || '20'} viewBox="0 0 27 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.5 10H5.5V8.33333H0.5V10ZM0.5 0V1.66667H15.5V0H0.5ZM0.5 5.83333H10.5V4.16667H0.5V5.83333Z" fill=${`"${col}"`}/>
        </svg>`;

  return baseXml;
}

export default Ascending;
